import AppConsoleTheme from './AppConsoleTheme';

export default {
  install(Vue) {
    const theme = new AppConsoleTheme();
    Vue.prototype.$appConsoleTheme = theme;
  },
};
